(function () {
    'use strict';

    angular
        .module('auditMandateRoutes', [
            'auditMandateModule',
            'services.historyCtxt'
        ])
        .config(router);

    router.$inject = ['$stateProvider', 'historyCtxtServiceProvider'];

    function router($stateProvider, historyCtxtServiceProvider) {
        $stateProvider
            .state('auditMandate', {
                url: '/AuditMandate',
                data: {
                    permissions: {
                        featureRole: 'RecomGrpBusinessUnit_Recom_InternalAuditManagement',
                        key: 'GovernanceProcess',
                        permission: 'View'
                    }
                },
                resolve: {
                    auditMandates: ['grcGovernanceProcessService', function (service) {
                        return service.getAuditMandateProcesses();
                    }]
                },
                views: {
                    '': {
                        template: '<div ui-view="mainContent"></div>'
                    },
                    'mainContent@auditMandate': {
                        templateUrl: require('./auditMandatesList.tpl.html'),
                        controller: 'AuditMandatesListController'
                    }
                }
            })
            .state('auditMandate.observations', {
                url: '/{AuditMandateID:int}/Observation',
                data: {
                    permissions: {
                        featureRole: 'RecomGrpBusinessUnit_Recom_InternalAuditManagement',
                        key: 'Observation',
                        permission: 'View'
                    }
                },
                params: historyCtxtServiceProvider.getStateParamsConfig(),
                resolve: {
                    auditMandate: ['$stateParams', 'auditMandates', function ($stateParams, auditMandates) {
                        return _.find(auditMandates, { GovernanceProcessID: $stateParams.AuditMandateID });
                    }]
                },
                views: {
                    'mainContent@auditMandate': {
                        templateUrl: require('./auditMandateObservationsList.tpl.html'),
                        controller: 'AuditMandateObservationsListController'
                    }
                }
            })

            // AuditMandate Add
            .state('auditMandateAdd', {
                url: '/AuditMandate/Add',
                templateUrl: require('./AuditMandateAdd.tpl.html'),
                controller: 'AuditMandateAddController',
                resolve: {
                    lookupAttributes: ['auditMandateService', function (service) {
                        return service.getLookupAttributes();
                    }]
                }
            })

            //// AuditMandate Not Exists
            //.state('auditMandateNotExists', {
            //    url: '/AuditMandate/{AuditMandateID:int}/NotExists',
            //    templateUrl: require('./auditMandateNotExists.tpl.html')
            //})

            // AuditMandate Edit
            .state('auditMandateEdit', {
                url: '/AuditMandate/{AuditMandateID:int}',
                params: historyCtxtServiceProvider.getStateParamsConfig(),
                resolve: {
                    auditMandate: ['$stateParams', 'auditMandateService', function ($stateParams, service) {
                        return service.getAuditMandate($stateParams.AuditMandateID);
                    }],
                    controls: ['auditMandate', 'auditMandateService', function (auditMandate, service) {
                        return service.getRelatedControls(auditMandate.AuditMandateID);
                    }],
                    lookupAttributes: ['auditMandateService', function (service) {
                        return service.getLookupAttributes();
                    }]
                },
                templateUrl: require('./AuditMandateEdit.tpl.html'),
                controller: 'AuditMandateEditController',
            });

        historyCtxtServiceProvider.setCtxtState('auditMandate',
            '/app/Main/auditMandate/GOVHistoryCtxtDirective-auditMandate.tpl.html'
        );
    }
})();
